import { generatePath, useHistory } from 'react-router-dom';
import {
  withTypes,
  Field,
} from 'react-final-form';
import queryString from 'query-string';
import classNames from 'classnames';
import { t } from 'ttag';

import defaultAvatarImage from '@static/img/default-avatar.png';
import { dialogDetails, login } from '@urls';
import { Title } from '@ui/Title';
import { Image } from '@ui/Image';
import { TextArea } from '@ui/TextArea';
import { Button } from '@ui/Button';
import { FormError } from '@ui/FormError';

import s from './ProductDetailsMessageForm.sss';

export interface FormData {
  body?: string,
}

interface User {
  username?: string,
  avatar?: string,
}

interface Props {
  className?: string,
  user?: User,
  threadId?: number,
  onSubmit: (formData: FormData) => void,
}

export const ProductDetailsMessageForm: React.FC<Props> = ({
  className,
  user,
  threadId,
  onSubmit,
}) => {
  const history = useHistory();
  const { Form } = withTypes<FormData>();

  const searchParams = queryString.stringify({
    next: location.pathname,
  });
  const loginUrl = history.createHref({
    pathname: login,
    search: searchParams,
  });
  const threadPathname = threadId ? generatePath(dialogDetails, { threadId }) : null;

  if (threadId && threadPathname) {
    return (
      <section className={classNames(s.root, className)}>
        <Button
          href={history.createHref({ pathname: threadPathname })}
        >
          {t`Перейти до вашої переписки`}
        </Button>
      </section>
    );
  }

  return (
    <section className={classNames(s.root, className)}>
      <Title
        className={s.title}
        type="h3"
        bold={false}
      >
        {t`Запитати продавця`}
      </Title>
      <div className={s.container}>
        <Image
          className={s.avatar}
          width="40"
          height="40"
          src={user?.avatar || defaultAvatarImage}
          alt={user?.username}
          lazy={true}
        />

        <Form
          onSubmit={onSubmit}
          render={({ handleSubmit, submitting, submitError }) => (
            <form className={s.form} onSubmit={handleSubmit}>
              <Field
                name="body"
              >
                {({ input, meta }) => (
                  <>
                    <TextArea
                      className={s.textarea}
                      placeholder={t`Текст повідомлення`}
                      rows={4}
                      withAutosize={true}
                      disabled={submitting}
                      error={(meta.touched && meta.error) || meta.submitError}
                      {...input}
                    />

                    {submitError && (
                      <FormError>
                        {submitError}
                      </FormError>
                    )}
                  </>
                )}
              </Field>

              <div className={s.footer}>
                {!!user && (
                  <>
                    <Button
                      className={s.submit}
                      type="submit"
                      disabled={submitting}
                    >
                      {submitting ? t`Надсилання...` : t`Надіслати`}
                    </Button>

                    <p className={s.info}>
                      {t`Листування буде видно тільки вам і продавцеві`}
                    </p>
                  </>
                )}

                {!user && (
                  <Button
                    className={s.submit}
                    onClick={() => {
                      window.location.href = loginUrl;
                    }}
                  >
                    {t`Увійти, щоб запитати продавця`}
                  </Button>
                )}
              </div>
            </form>
          )}
        />
      </div>
    </section>
  );
};
